import { DAIMI_CG_INTRO, DAIMI_CG_SLUG } from '@/content/daimiConsumerGoods'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The second report of the thirty-one whose own copy was supplied, and the
  // second with a page of its own — the live page's WordPress shortcode was
  // pasted in full on 2026-08-27 with two screenshots and five figures, so
  // both the words and the layout are the sector's rather than the series'.
  ...focus(
    DAIMI_CG_SLUG,
    'Consumer Goods',
    'daimi-report-2026-consumer-goods-cover',
    '5d7634aa-4d46-42bf-8753-62769c257bc8-digitopia-daimi-2026-report-consumergoods.pdf',
  ),
  // The page's own opening paragraphs, verbatim from the shortcode, so the
  // search result and the page agree — `prerender.tsx` takes the meta
  // description from `body[0]`.
  body: DAIMI_CG_INTRO.body,
  layout: 'consumer-goods-focus',
  // Nothing left for `stillToCome` to say: file, cover and its own words. The
  // two questions this page does raise are section-by-section, and
  // `daimiConsumerGoodsChecks()` carries them into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 8
